const OffsiteSymbol = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Union"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4405 3.34814H7.19052C6.68426 3.34814 6.27385 3.75855 6.27385 4.26481C6.27385 4.77107 6.68426 5.18148 7.19052 5.18148L13.2275 5.18148L5.62566 12.7833C5.26768 13.1413 5.26768 13.7217 5.62566 14.0797C5.98364 14.4376 6.56404 14.4376 6.92202 14.0797L14.5238 6.47784L14.5238 12.5148C14.5238 13.0211 14.9343 13.4315 15.4405 13.4315C15.9468 13.4315 16.3572 13.0211 16.3572 12.5148V4.26481C16.3572 3.75855 15.9468 3.34814 15.4405 3.34814ZM6 16.3481C5.44772 16.3481 5 16.7959 5 17.3481C5 17.9004 5.44771 18.3481 6 18.3481H15C15.5523 18.3481 16 17.9004 16 17.3481C16 16.7959 15.5523 16.3481 15 16.3481H6Z"
      fill="#6E3264"
    />
  </svg>
)

export default OffsiteSymbol
